function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { createContext, useContext, useState, useEffect } from 'react';
import { ConfigProvider, theme as antdTheme } from 'antd';
import { themes as defaultThemes, DEFAULT_THEME_KEY } from './themes';
import { jsx as _jsx } from "react/jsx-runtime";
var ThemeContext = /*#__PURE__*/createContext(null);
export var useTheme = () => {
  var ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return ctx;
};

/**
 * Shared ThemeProvider used by both tenant-console and vendor-console.
 *
 * - Persists the active theme key in localStorage under `app-theme`.
 * - Mirrors every token onto the document root as `--theme-*` CSS vars
 *   so existing CSS keeps working unchanged.
 * - Wraps children in an antd `ConfigProvider` with light/dark algorithm.
 *
 * Both consoles MUST mount this exactly once, near the root, so AntD
 * tokens and CSS variables agree across the whole tree.
 */
export var ThemeProvider = _ref => {
  var children = _ref.children,
    _ref$themes = _ref.themes,
    themes = _ref$themes === void 0 ? defaultThemes : _ref$themes,
    _ref$defaultThemeKey = _ref.defaultThemeKey,
    defaultThemeKey = _ref$defaultThemeKey === void 0 ? DEFAULT_THEME_KEY : _ref$defaultThemeKey,
    _ref$storageKey = _ref.storageKey,
    storageKey = _ref$storageKey === void 0 ? 'app-theme' : _ref$storageKey;
  var _useState = useState(() => {
      try {
        var saved = localStorage.getItem(storageKey);
        return saved && themes[saved] ? saved : defaultThemeKey;
      } catch (_unused) {
        return defaultThemeKey;
      }
    }),
    _useState2 = _slicedToArray(_useState, 2),
    currentTheme = _useState2[0],
    setCurrentTheme = _useState2[1];
  var themeConfig = themes[currentTheme] || themes[defaultThemeKey];
  useEffect(() => {
    var root = document.documentElement;
    Object.entries(themeConfig).forEach(_ref2 => {
      var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        cssValue = _ref3[1];
      if (key !== 'name' && key !== 'mode') {
        root.style.setProperty("--theme-".concat(key), cssValue);
      }
    });
  }, [themeConfig]);
  var changeTheme = themeKey => {
    if (themes[themeKey]) {
      setCurrentTheme(themeKey);
      try {
        localStorage.setItem(storageKey, themeKey);
      } catch (_unused2) {/* ignore */}
    }
  };
  var antdThemeConfig = {
    algorithm: themeConfig.mode === 'dark' ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
    token: {
      colorPrimary: themeConfig.primary,
      colorInfo: themeConfig.primary,
      colorSuccess: '#10b981',
      borderRadius: 6,
      colorBgContainer: themeConfig.contentBg,
      colorBgElevated: themeConfig.contentBg
    }
  };
  var value = {
    currentTheme,
    themeConfig,
    themes,
    changeTheme
  };
  return /*#__PURE__*/_jsx(ThemeContext.Provider, {
    value: value,
    children: /*#__PURE__*/_jsx(ConfigProvider, {
      theme: antdThemeConfig,
      tag: {
        variant: 'outlined'
      },
      children: children
    })
  });
};